// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__3saYm","ttl":"Modal_ttl__2STi7","body":"Modal_body__2QKfe"};